import clsx from 'clsx';
import { Anchor, Referenz, Show } from 'components/atoms';
import React from 'react';
import { FunktionsTimelineItem, FunktionsTimelineZeitpunkt } from 'types';
import { useTranslation } from 'utils/hooks';

import css from './FunktionsGrid.module.scss';

interface FunktionsGridProps
{
  data: FunktionsTimelineZeitpunkt;
}

const FunktionsGrid: React.FC<FunktionsGridProps> = (props) =>
{
  const { data } = props;
  const { t } = useTranslation(['formats', 'funktionen', 'profiles']);
  
  const filteredFunktionen = data.items.filter(funktion => funktion.änderungsArt !== 'Gelöscht');

  function renderItem(item: FunktionsTimelineItem)
  {
    return (
      <li key={item.key} className={css.itemContainer}>
        <Referenz data={item.ref}>
          {({ href, ref }) => (
            <Anchor
              href={href}
              className={css.item}
            >
              <span className={css.name}>{ref.name}</span>
              <span>{t(`funktionen:list.${item.funktion}`)}</span>
            </Anchor>
          )}
        </Referenz>
        
      </li>
    );
  }

  return (
    <div className={css.container}>
      <h4 className={css.heading}>
        {t('profiles:currentSince', { date: data.date }) }
      </h4>

      <div className={css.container}>

        <Show when={filteredFunktionen.length > 0}>
          <ul className={clsx('scrollbars', css.grid)}>
            {filteredFunktionen.map((funktion) => renderItem(funktion))}
          </ul>
        </Show>

        <Show when={filteredFunktionen.length === 0}>
          <p>{t('profiles:noActiveFunctionsSince', { date: data.date })}</p>
        </Show>
      </div>
    </div>
  );
};

export default FunktionsGrid;
